import { inject, Injectable } from '@angular/core';
import { portalConst } from '@app/config';
import { Observable } from 'rxjs';
import { ApiService, Resp } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class SubjectService {
  private readonly _api = inject(ApiService);
  private readonly _url = `${portalConst.api.eclass}/v1/subjects`;

  public list(data?: any): Observable<Resp<any[]>> {
    return this._api.get<any[]>(`${this._url}`, data);
  }

  public subjectByGroup(groupId: number, req?: any): Observable<any[]> {
    return this._api.list<any[]>(`${portalConst.api.usuario}/v1/lista-disciplinas-turma/${groupId}`, req);
  }

  public subjectByGrade(gradeId: number, req?: any): Observable<any[]> {
    return this._api.list<any[]>(`${portalConst.api.usuario}/v1/lista-disciplinas-serie/${gradeId}`, req);
  }
}
